<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import SelecteurModeEvaluation from '@/components/generiques/SelecteurModeEvaluation.vue';

const { idErreur, proposerModeCle, desactive } = defineProps({
    idErreur: String,
    proposerModeCle: Boolean,
    desactive: Boolean
});

const valeur = defineModel('valeur', {
    type: String
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(mode) {
    valeur.value = mode;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <SelecteurModeEvaluation 
            v-model:modeEvaluation="valeur"
            :proposerModeCle="proposerModeCle"
            :desactive="desactive"
            @modification="modifierValeur" />
    </Saisie>
</template>

<style scoped>

</style>